module.exports = __webpack_public_path__ + "img/9.113c007f.png";